// import logo from "./logo.svg";
import MainComponent from "./components/MainComponent";
import "./App.css";

function App() {
  return (
    <div className="App">
      <MainComponent />
    </div>
  );
}
export default App;
